import React from 'react';
import { BusinessPlan } from '../../types/businessPlan';

interface VersionHistoryProps {
  versions: BusinessPlan[];
  onRestore: (version: number) => void;
  onClose: () => void;
}

const VersionHistory: React.FC<VersionHistoryProps> = ({
  versions,
  onRestore,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium text-gray-900">Version History</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <span className="sr-only">Close</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          {versions.map((version) => (
            <div
              key={version.version}
              className="border rounded-lg p-4 hover:bg-gray-50"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="text-sm font-medium text-gray-900">
                    Version {version.version}
                  </h4>
                  <p className="text-sm text-gray-500">
                    {new Date(version.created_at).toLocaleString()}
                  </p>
                </div>
                <button
                  onClick={() => onRestore(version.version)}
                  className="ml-4 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Restore
                </button>
              </div>

              <div className="mt-2 text-sm text-gray-700">
                <h5 className="font-medium">Changes:</h5>
                <ul className="list-disc list-inside space-y-1">
                  {version.content && Object.entries(version.content as Record<string, string>).map(([section, content]) => (
                    <li key={section}>
                      {section.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                      {' '}
                      ({(content as string).length} characters)
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VersionHistory;
